import { Controller } from 'react-hook-form'
import { SearchIcon } from '../../assets/icons/search'
import { colors } from '../../theme'

import { ContainerTitle, DivTitle } from '../../components/TitlePage/TitlePage'
import { Container } from '../../layouts/LayoutTable/LayoutTable'
import { GenericTable } from '../../components/GenericTable/GenericTable'

import { Pagination } from '../../components/Pagination/Pagination'
import { Loading } from '../../components/Loading/Loading'

import {
  DivInput,
  Div,
  InputStyle,
  Span,
  BaseIntegracao,
  BaseEdit,
  Search,
  ButtonNewUser,
} from './style'
import { FormLogin } from '../NewUsers/NewUsers.style'
import ToggleSwitch from '../../components/Switch/Switch'
import { EditIcon } from '../../assets/icons/EditIcon'
import Integracao from '../../assets/icons/integracao'
import { PlusIcon } from '../../assets/icons/Plus'
import { useOrganizacoesAdmin } from './useOrganizacoesAdmin'
import Tooltips from '../../components/Tooltip'
import { Desativar } from '../../components/Desativar'
import { WhatsappIcon } from '../../assets/icons/whatsapp-line'

export function Organizacoes() {
  const {
    searchValue,
    setSearchValue,
    currentPage,
    setCurrentPage,
    fetchOrganizationListAll,
    isLoading,
    handleKeyDown,
    inativaOrganizacao,
    setInativaOrganizacao,
    fechaInativaOrganizacao,
    useOrganizationsListAll,
    control,
    ativar,
    desativar,
    setOrganizacaoId,
    status,
    setStatus,
    irParaNovaOrganizacao,
    irParaEditarOrganizacao,
  } = useOrganizacoesAdmin()

  return (
    <>
      <DivTitle color="black" size={22}>
        <ContainerTitle>Organizações</ContainerTitle>
      </DivTitle>
      <Container>
        <DivInput>
          <Search>
            <InputStyle
              value={searchValue}
              onChange={event => setSearchValue(event.target.value)}
              onKeyDown={handleKeyDown}
              border={colors.grey300}
              placeholder="Pesquise por organização"
              sizeX="264px"
              sizeY="42px"
            />
            <ButtonNewUser type="button" onClick={irParaNovaOrganizacao}>
              <PlusIcon /> Novo
            </ButtonNewUser>
          </Search>
          <Span onClick={fetchOrganizationListAll}>
            <SearchIcon />
          </Span>

          <div>
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              <>
                <GenericTable
                  size="270px"
                  headers={['Nome', 'Sub-domínio', '']}
                  spacing="40px"
                  font="16px"
                  vendas
                  text
                >
                  {useOrganizationsListAll.content != null &&
                    useOrganizationsListAll.content.map(organizacao => (
                      <tr className="" key={organizacao.id}>
                        <td className="colVendas7">{organizacao.nome}</td>
                        <td className="colVendas7">{organizacao.tenantId}</td>
                        <td className="colIcon">
                          <Div>
                            <Tooltips
                              icon={
                                <BaseIntegracao as="div">
                                  <WhatsappIcon
                                    color
                                    ativo={organizacao.integracaoWhatsappAtiva}
                                  />
                                </BaseIntegracao>
                              }
                              text={
                                organizacao.integracaoWhatsappAtiva
                                  ? 'WhatsApp ativo'
                                  : 'WhatsApp inativo'
                              }
                            />
                            <Tooltips
                              icon={
                                <BaseIntegracao as="div">
                                  <Integracao
                                    ativo={organizacao.integracaoW3erpAtiva}
                                  />
                                </BaseIntegracao>
                              }
                              text={
                                organizacao.integracaoW3erpAtiva
                                  ? 'Integração ativa'
                                  : 'Integração inativa'
                              }
                            />
                            <Tooltips
                              icon={
                                <BaseEdit
                                  type="button"
                                  onClick={() =>
                                    irParaEditarOrganizacao(organizacao)
                                  }
                                >
                                  <EditIcon />
                                </BaseEdit>
                              }
                              text="Gerenciar"
                            />
                            <Tooltips
                              icon={
                                <FormLogin id="ativoInativo">
                                  <Controller
                                    name="isActive"
                                    control={control}
                                    render={({ field: { ref, ...field } }) => (
                                      <ToggleSwitch
                                        adm
                                        checked={organizacao.ativo}
                                        id="status"
                                        {...field}
                                        onClick={() => {
                                          setInativaOrganizacao(true)
                                          setOrganizacaoId(organizacao.id)
                                          setStatus(organizacao.ativo)
                                        }}
                                      />
                                    )}
                                  />
                                </FormLogin>
                              }
                              text="Ativar / Desativar"
                            />
                          </Div>
                        </td>
                      </tr>
                    ))}
                </GenericTable>
                <Pagination
                  pageNumber={currentPage}
                  pageSize={useOrganizationsListAll.totalElements}
                  offSet={useOrganizationsListAll.size}
                  onClick={page => setCurrentPage(page)}
                />
              </>
            )}
          </div>
        </DivInput>
      </Container>

      {inativaOrganizacao && (
        <Desativar
          texto={
            status
              ? 'Deseja realmente desativar esta organização?'
              : 'Deseja realmente ativar esta organização?'
          }
          botaoNao={() => {
            fechaInativaOrganizacao()
          }}
          botaoSim={status ? desativar : ativar}
        />
      )}
    </>
  )
}
